<template>
  <div>
    <transition-group tag="div" name="gallery" mode="out-in">
      <v-responsive :key="currentVideoGalleryIndex" :aspect-ratio="16/9">
        <vue-plyr
          v-show="index === currentVideoGalleryIndex"
          v-for="(video, index) in videos"
          :key="index"
          class="player"
          ref="plyr"
        >
          <div
            :data-plyr-embed-id="getYoutubeId(video.videoLink)"
            data-plyr-provider="youtube"
            data-target="video.player"
          ></div>
        </vue-plyr>
      </v-responsive>
    </transition-group>
    <div
      v-if="videos && videos.length > 1"
      class="d-flex align-center justify-space-around d-md-block mt-6 mt-md-0"
    >
      <button
        @click.stop="moveVideoGallery"
        type="button"
        class="prev"
      >
        <iconPrevious />
      </button>
      <button
        @click.stop="moveVideoGallery"
        type="button"
        class="next"
      >
        <iconNext />
      </button>
    </div>
  </div>
</template>

<script>
import VuePlyr from 'vue-plyr'
import Vue from 'vue'
import 'plyr/src/sass/plyr.scss' // eslint-disable-line

import iconPrevious from '@/assets/svg/icon-previous.svg'
import iconNext from '@/assets/svg/icon-next.svg'

// The second argument is optional and sets the default config values for every player.
Vue.use(VuePlyr, {
  plyr: {
    controls: ['play', 'progress', 'volume', 'fullscreen'],
    fullscreen: { enabled: true },
    loop: { active: false },
    playsinline: true,
    autoplay: false,
    muted: false
  }
})

export default {
  name: 'VideoGallery',
  props: {
    videos: { type: Array }
  },
  components: {
    iconPrevious,
    iconNext
  },
  data () {
    return {
      currentVideoGalleryIndex: 0
    }
  },
  methods: {
    getYoutubeId (url) {
      const match = url.match(/^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/) // eslint-disable-line
      return (match && match[7].length === 11) ? match[7] : false
    },
    moveVideoGallery () {
      this.currentVideoGalleryIndex =
        this.currentVideoGalleryIndex - 1 < 0
          ? this.videos.length - 1
          : this.currentVideoGalleryIndex - 1
    }
  }
}
</script>

<style lang="scss" scoped>
.gallery-enter-active,
.gallery-leave-active {
  transition: 1s ease-in-out;
}

.gallery-enter,
.gallery-leave-to {
  position: absolute;
  opacity: 0;
}

::v-deep .plyr__control--overlaid {
  background: $c-pink;
  padding: 50px;

  &:hover {
    background: $c-white !important;

    svg {
      fill: $c-pink;
    }
  }
}

::v-deep .plyr--full-ui input[type=range] {
  color: $c-pink;
}

::v-deep .plyr--video .plyr__control.plyr__tab-focus,
::v-deep .plyr--video .plyr__control:hover,
::v-deep .plyr--video .plyr__control[aria-expanded=true] {
  background: $c-pink;
}

// Remove youtube title, share and video recommendations on paused video
// https://github.com/sampotts/plyr/issues/1222
::v-deep .plyr__video-embed iframe {
  top: -50%;
  height: 200%;
}

button {
  outline: none;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  transition: transform 0.25s ease-out;

  @include breakpoint ('sm-and-down') {
    position: relative;
    top: 0;
    transform: translateY(0);
  }

  &.prev {
    left: 25px;
  }

  &.next {
    right: 25px;
  }

  &:hover {
    transform: translateY(-50%) scale(1.1);

    @include breakpoint ('sm-and-down') {
      transform: none;
    }
  }
}

</style>
